import React, { useState, useEffect } from "react"
import { useLocation } from '@reach/router';
import { InquiryForm, LangCode } from "../utils/lang"
import moment from 'moment'
import { init, Form } from '@feathery/react';
import { Trans } from "../utils/lang"

const TourPeriod = ({ blok }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const affiliate = queryParams.get('affiliate');
  const period = queryParams.get('period') ? parseInt(queryParams.get('period')) : 0;
  
  const isPastDate = (dateString, cutoffDays) => {
    const cutoffDate = moment().startOf('day').add(cutoffDays ? cutoffDays : 30, 'days');  // default cutoff 30 days
    return dateString && moment(dateString).isBefore(cutoffDate);
  };
  blok.tourPeriods?.forEach(period => {
    period.optionValue = period.customOption 
      ? period.customOption 
      : `${period.fromDate ? moment(period.fromDate).format('MMM D, YYYY') : ''} - ${period.toDate ? moment(period.toDate).format('MMM D, YYYY') : ''}`;
    period.isPastDate = isPastDate(period.fromDate, period.cutoffDays);
  });

  const firstValidIndex = blok.tourPeriods?.findIndex(period => !period.isPastDate);
  const periodIndex = (firstValidIndex !== undefined && (period === 0 || period >= blok.tourPeriods?.length)) ? firstValidIndex : period;
  
  // useEffect to force set select value to periodIndex
  useEffect(() => {
    // console.log('periodIndex', periodIndex);
    const select = document.querySelector('select[name="period"]');
    if (select) {
      select.value = periodIndex;
    }
  }, [periodIndex]);

  // console.log(period, firstValidIndex, periodIndex, typeof(periodIndex));
  // console.log(blok.tourPeriods, blok.tourInquiryForm);

  // Initialize Feathery Form
  const langCode = LangCode();
  const inquryForm = InquiryForm();
  const formName = inquryForm["formName"];
  const tourFieldId0 = inquryForm["tourFieldId0"];
  const tourFieldId1 = inquryForm["tourFieldId1"];
  const tourPeriodId = inquryForm["tourPeriodId"];

  var initialValues = {}
  initialValues['affiliate'] = affiliate ? affiliate : '';
  if(periodIndex >= 0 && periodIndex < blok.tourPeriods?.length) {
    initialValues[tourPeriodId] = blok.tourPeriods[periodIndex].optionValue;
  }
  if (blok.tourInquiryForm?.length > 0) {
    if(blok.tourInquiryForm[0].tourValue0) initialValues[tourFieldId0] = blok.tourInquiryForm[0].tourValue0;
    if(blok.tourInquiryForm[0].tourValue1) initialValues[tourFieldId1] = blok.tourInquiryForm[0].tourValue1;
    if(blok.tourInquiryForm[0].tourCode) initialValues["tourCode"] = blok.tourInquiryForm[0].tourCode;
  }
  // console.log(inquryForm, periodIndex, initialValues);
  
  init('eeaa5623-09b6-42e5-944d-b11974b0154b');
  const [showPopup, setShowPopup] = useState(false);
  
  

  

  return (
    <div className="pt-3">
      {
      blok.tourPeriods?.length > 0 &&
      <select name="period" value={periodIndex} onChange={e => { window.location.href = `${window.location.pathname}?period=${e.target.value}`;}}
        className="border-b border-black w-4/5 mx-auto">
        {blok.tourPeriods.map((period, i) => (
          !period.isPastDate  &&
          <option key={i} value={i}>
            { period.optionValue }
          </option>
        ))}
      </select>
      }

      <div className="mt-3">
        <button onClick={() => setShowPopup(true)} className="text-blue-700 hover:font-bold">
          <span>{Trans('checkAvailability')}</span>
          <img className="w-6 inline-block ml-2" src="/icons/arrow-right-blue.svg" alt="Arrow right" />
        </button>
        <Form
          className="bg-white"
          formName={formName}
          initialValues={initialValues}
          language={langCode}
          popupOptions={{
            show: showPopup,
            onHide: () => setShowPopup(false),
          }}
        />
      </div>

    </div>
  )
};

export default TourPeriod;
